import VistaPlanes from "@/views/VistaPlanes.vue";

const planes = {
  path: "/app/planes",
  name: "planes",
  component: VistaPlanes,
};

export default planes;
